module.exports = __webpack_public_path__ + "img/bf-bg-long.122beeed.png";